import { render } from "./CouponDetail.vue?vue&type=template&id=804bda3a&scoped=true&ts=true"
import script from "./CouponDetail.vue?vue&type=script&lang=ts"
export * from "./CouponDetail.vue?vue&type=script&lang=ts"

import "./CouponDetail.vue?vue&type=style&index=0&id=804bda3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804bda3a"]])

export default __exports__